import React, { useEffect, useRef, useState } from 'react';
import { DotsThreeVertical } from '@phosphor-icons/react';

/**
 * Trailing "⋯" menu for list rows with 2+ actions (Edit/Delete/etc.) — keeps
 * the row's only obvious click target its title link, instead of several
 * bare buttons competing with whole-row navigation.
 */
function RowActionsMenu({ actions }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div ref={ref} onClick={(e) => e.stopPropagation()} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        aria-label="Row actions" aria-haspopup="menu" aria-expanded={open}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '28px', height: '28px', background: 'none', border: 'none',
          borderRadius: '6px', cursor: 'pointer', color: '#6B7280',
        }}>
        <DotsThreeVertical size={18} weight="bold" />
      </button>
      {open && (
        <div role="menu" style={{
          position: 'absolute', right: 0, top: '100%', marginTop: '4px', zIndex: 20,
          background: 'white', border: '1px solid #E5E7EB', borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.12)', minWidth: '150px', overflow: 'hidden',
        }}>
          {actions.map((a, i) => (
            <button key={i} type="button" role="menuitem"
              onClick={() => { setOpen(false); a.onClick(); }}
              style={{
                display: 'block', width: '100%', textAlign: 'left', padding: '9px 12px',
                background: 'none', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: '500',
                color: a.danger ? '#B91C1C' : '#374151',
              }}>
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default RowActionsMenu;
